// extracted by mini-css-extract-plugin
module.exports = {"bottomSection":"bottom_bottomSection__F8_7D","bottomWrap":"bottom_bottomWrap___8A_C","formInput":"bottom_formInput__payk4","formSubmit":"bottom_formSubmit__MBqSh"};